export const countryOptions = [
  { key: "af", value: "af", flag: "af", text: "Afghanistan" },
  { key: "ax", value: "ax", flag: "ax", text: "Aland Islands" },
  { key: "al", value: "al", flag: "al", text: "Albania" },
  { key: "dz", value: "dz", flag: "dz", text: "Algeria" },
  { key: "as", value: "as", flag: "as", text: "American Samoa" },
  { key: "ad", value: "ad", flag: "ad", text: "Andorra" },
  { key: "ao", value: "ao", flag: "ao", text: "Angola" },
  { key: "ai", value: "ai", flag: "ai", text: "Anguilla" },
  { key: "ag", value: "ag", flag: "ag", text: "Antigua" },
  { key: "ar", value: "ar", flag: "ar", text: "Argentina" },
  { key: "am", value: "am", flag: "am", text: "Armenia" },
  { key: "aw", value: "aw", flag: "aw", text: "Aruba" },
  { key: "au", value: "au", flag: "au", text: "Australia" },
  { key: "at", value: "at", flag: "at", text: "Austria" },
  { key: "az", value: "az", flag: "az", text: "Azerbaijan" },
  { key: "bs", value: "bs", flag: "bs", text: "Bahamas" },
  { key: "bh", value: "bh", flag: "bh", text: "Bahrain" },
  { key: "bd", value: "bd", flag: "bd", text: "Bangladesh" },
  { key: "bb", value: "bb", flag: "bb", text: "Barbados" },
  { key: "by", value: "by", flag: "by", text: "Belarus" },
  { key: "be", value: "be", flag: "be", text: "Belgium" },
  { key: "bz", value: "bz", flag: "bz", text: "Belize" },
  { key: "bj", value: "bj", flag: "bj", text: "Benin" },
  { key: "bm", flag: "bm", text: "Bermuda", value: "bm" },
  { key: "bt", flag: "bt", text: "Bhutan", value: "bt" },
  { key: "bo", flag: "bo", text: "Bolivia", value: "bo" },
  { key: "ba", flag: "ba", text: "Bosnia", value: "ba" },
  { key: "bw", flag: "bw", text: "Botswana", value: "bw" },
  { key: "bv", flag: "bv", text: "Bouvet Island", value: "bv" },
  { key: "br", flag: "br", text: "Brazil", value: "br" },
  { key: "vg", flag: "vg", text: "British Virgin Islands", value: "vg" },
  { key: "bn", flag: "bn", text: "Brunei", value: "bn" },
  { key: "bg", flag: "bg", text: "Bulgaria", value: "bg" },
  { key: "bf", flag: "bf", text: "Burkina Faso", value: "bf" },
  { key: "mm", flag: "mm", text: "Burma", value: "mm", alias: "Myanmar" },
  { key: "bi", flag: "bi", text: "Burundi", value: "bi" },
  { key: "tc", flag: "tc", text: "Caicos Islands", value: "tc" },
  { key: "kh", flag: "kh", text: "Cambodia", value: "kh" },
  { key: "cm", flag: "cm", text: "Cameroon", value: "cm" },
  { key: "ca", flag: "ca", text: "Canada", value: "ca" },
  { key: "cv", flag: "cv", text: "Cape Verde", value: "cv" },
  { key: "ky", flag: "ky", text: "Cayman Islands", value: "ky" },
  { key: "cf", flag: "cf", text: "Central African Republic", value: "cf" },
  { key: "td", flag: "td", text: "Chad", value: "td" },
  { key: "cl", flag: "cl", text: "Chile", value: "cl" },
  { key: "cn", flag: "cn", text: "China", value: "cn" },
  { key: "cx", flag: "cx", text: "Christmas Island", value: "cx" },
  { key: "cc", flag: "cc", text: "Cocos Islands", value: "cc" },
  { key: "co", flag: "co", text: "Colombia", value: "co" },
  { key: "km", flag: "km", text: "Comoros", value: "km" },
  { key: "cd", flag: "cd", text: "Congo", value: "cd" },
  { key: "cg", flag: "cg", text: "Congo Brazzaville", value: "cg" },
  { key: "ck", flag: "ck", text: "Cook Islands", value: "ck" },
  { key: "cr", flag: "cr", text: "Costa Rica", value: "cr" },
  { key: "ci", flag: "ci", text: "Cote Divoire", value: "ci" },
  { key: "hr", flag: "hr", text: "Croatia", value: "hr" },
  { key: "cu", flag: "cu", text: "Cuba", value: "cu" },
  { key: "cy", flag: "cy", text: "Cyprus", value: "cy" },
  { key: "cz", flag: "cz", text: "Czech Republic", value: "cz" },
  { key: "dk", flag: "dk", text: "Denmark", value: "dk" },
  { key: "dj", flag: "dj", text: "Djibouti", value: "dj" },
  { key: "dm", flag: "dm", text: "Dominica", value: "dm" },
  { key: "do", flag: "do", text: "Dominican Republic", value: "do" },
  { key: "ec", flag: "ec", text: "Ecuador", value: "ec" },
  { key: "eg", flag: "eg", text: "Egypt", value: "eg" },
  { key: "sv", flag: "sv", text: "El Salvador", value: "sv" },
  { key: "gb", flag: "gb", text: "England", value: "gb eng" },
  { key: "gq", flag: "gq", text: "Equatorial Guinea", value: "gq" },
  { key: "er", flag: "er", text: "Eritrea", value: "er" },
  { key: "ee", flag: "ee", text: "Estonia", value: "ee" },
  { key: "et", flag: "et", text: "Ethiopia", value: "et" },
  { key: "eu", flag: "eu", text: "Europeanunion", value: "eu" },
  { key: "fk", flag: "fk", text: "Falkland Islands", value: "fk" },
  { key: "fo", flag: "fo", text: "Faroe Islands", value: "fo" },
  { key: "fj", flag: "fj", text: "Fiji", value: "fj" },
  { key: "fi", flag: "fi", text: "Finland", value: "fi" },
  { key: "fr", flag: "fr", text: "France", value: "fr" },
  { key: "gf", flag: "gf", text: "French Guiana", value: "gf" },
  { key: "pf", flag: "pf", text: "French Polynesia", value: "pf" },
  { key: "tf", flag: "tf", text: "French Territories", value: "tf" },
  { key: "ga", flag: "ga", text: "Gabon", value: "ga" },
  { key: "gm", flag: "gm", text: "Gambia", value: "gm" },
  { key: "ge", flag: "ge", text: "Georgia", value: "ge" },
  { key: "de", flag: "de", text: "Germany", value: "de" },
  { key: "gh", flag: "gh", text: "Ghana", value: "gh" },
  { key: "gi", flag: "gi", text: "Gibraltar", value: "gi" },
  { key: "gr", flag: "gr", text: "Greece", value: "gr" },
  { key: "gl", flag: "gl", text: "Greenland", value: "gl" },
  { key: "gd", flag: "gd", text: "Grenada", value: "gd" },
  { key: "gp", flag: "gp", text: "Guadeloupe", value: "gp" },
  { key: "gu", flag: "gu", text: "Guam", value: "gu" },
  { key: "gt", flag: "gt", text: "Guatemala", value: "gt" },
  { key: "gn", flag: "gn", text: "Guinea", value: "gn" },
  { key: "gw", flag: "gw", text: "Guinea-Bissau", value: "gw" },
  { key: "gy", flag: "gy", text: "Guyana", value: "gy" },
  { key: "ht", flag: "ht", text: "Haiti", value: "ht" },
  { key: "hm", flag: "hm", text: "Heard Island", value: "hm" },
  { key: "hn", flag: "hn", text: "Honduras", value: "hn" },
  { key: "hk", flag: "hk", text: "Hong Kong", value: "hk" },
  { key: "hu", flag: "hu", text: "Hungary", value: "hu" },
  { key: "is", flag: "is", text: "Iceland", value: "is" },
  { key: "in", flag: "in", text: "India", value: "in" },
  { key: "io", flag: "io", text: "Indian Ocean Territory", value: "io" },
  { key: "id", flag: "id", text: "Indonesia", value: "id" },
  { key: "ir", flag: "ir", text: "Iran", value: "ir" },
  { key: "iq", flag: "iq", text: "Iraq", value: "iq" },
  { key: "ie", flag: "ie", text: "Ireland", value: "ie" },
  { key: "il", flag: "il", text: "Israel", value: "il" },
  { key: "it", flag: "it", text: "Italy", value: "it" },
  { key: "jm", flag: "jm", text: "Jamaica", value: "jm" },
  { key: "sj", flag: "sj", text: "Jan Mayen", value: "sj", alias: "Svalbard" },
  { key: "jp", flag: "jp", text: "Japan", value: "jp" },
  { key: "jo", flag: "jo", text: "Jordan", value: "jo" },
  { key: "kz", flag: "kz", text: "Kazakhstan", value: "kz" },
  { key: "ke", flag: "ke", text: "Kenya", value: "ke" },
  { key: "ki", flag: "ki", text: "Kiribati", value: "ki" },
  { key: "xk", flag: "xk", text: "Kosovo ", value: "xk" },
  { key: "kw", flag: "kw", text: "Kuwait", value: "kw" },
  { key: "kg", flag: "kg", text: "Kyrgyzstan", value: "kg" },
  { key: "la", flag: "la", text: "Laos", value: "la" },
  { key: "lv", flag: "lv", text: "Latvia", value: "lv" },
  { key: "lb", flag: "lb", text: "Lebanon", value: "lb" },
  { key: "ls", flag: "ls", text: "Lesotho", value: "ls" },
  { key: "lr", flag: "lr", text: "Liberia", value: "lr" },
  { key: "ly", flag: "ly", text: "Libya", value: "ly" },
  { key: "li", flag: "li", text: "Liechtenstein", value: "li" },
  { key: "lt", flag: "lt", text: "Lithuania", value: "lt" },
  { key: "lu", flag: "lu", text: "Luxembourg", value: "lu" },
  { key: "mo", flag: "mo", text: "Macau", value: "mo" },
  { key: "mk", flag: "mk", text: "Macedonia", value: "mk" },
  { key: "mg", flag: "mg", text: "Madagascar", value: "mg" },
  { key: "mw", flag: "mw", text: "Malawi", value: "mw" },
  { key: "my", flag: "my", text: "Malaysia", value: "my" },
  { key: "mv", flag: "mv", text: "Maldives", value: "mv" },
  { key: "ml", flag: "ml", text: "Mali", value: "ml" },
  { key: "mt", flag: "mt", text: "Malta", value: "mt" },
  { key: "mh", flag: "mh", text: "Marshall Islands", value: "mh" },
  { key: "mq", flag: "mq", text: "Martinique", value: "mq" },
  { key: "mr", flag: "mr", text: "Mauritania", value: "mr" },
  { key: "mu", flag: "mu", text: "Mauritius", value: "mu" },
  { key: "yt", flag: "yt", text: "Mayotte", value: "yt" },
  { key: "mx", flag: "mx", text: "Mexico", value: "mx" },
  { key: "fm", flag: "fm", text: "Micronesia", value: "fm" },
  { key: "md", flag: "md", text: "Moldova", value: "md" },
  { key: "mc", flag: "mc", text: "Monaco", value: "mc" },
  { key: "mn", flag: "mn", text: "Mongolia", value: "mn" },
  { key: "me", flag: "me", text: "Montenegro", value: "me" },
  { key: "ms", flag: "ms", text: "Montserrat", value: "ms" },
  { key: "ma", flag: "ma", text: "Morocco", value: "ma" },
  { key: "mz", flag: "mz", text: "Mozambique", value: "mz" },
  { key: "na", flag: "na", text: "Namibia", value: "na" },
  { key: "nr", flag: "nr", text: "Nauru", value: "nr" },
  { key: "np", flag: "np", text: "Nepal", value: "np" },
  { key: "nl", flag: "nl", text: "Netherlands", value: "nl" },
  { key: "an", flag: "an", text: "Netherlandsantilles", value: "an" },
  { key: "nc", flag: "nc", text: "New Caledonia", value: "nc" },
  { key: "pg", flag: "pg", text: "New Guinea", value: "pg" },
  { key: "nz", flag: "nz", text: "New Zealand", value: "nz" },
  { key: "ni", flag: "ni", text: "Nicaragua", value: "ni" },
  { key: "ne", flag: "ne", text: "Niger", value: "ne" },
  { key: "ng", flag: "ng", text: "Nigeria", value: "ng" },
  { key: "nu", flag: "nu", text: "Niue", value: "nu" },
  { key: "nf", flag: "nf", text: "Norfolk Island", value: "nf" },
  { key: "kp", flag: "kp", text: "North Korea", value: "kp" },
  { key: "mp", flag: "mp", text: "Northern Mariana Islands", value: "mp" },
  { key: "no", flag: "no", text: "Norway", value: "no" },
  { key: "om", flag: "om", text: "Oman", value: "om" },
  { key: "pk", flag: "pk", text: "Pakistan", value: "pk" },
  { key: "pw", flag: "pw", text: "Palau", value: "pw" },
  { key: "ps", flag: "ps", text: "Palestine", value: "ps" },
  { key: "pa", flag: "pa", text: "Panama", value: "pa" },
  { key: "py", flag: "py", text: "Paraguay", value: "py" },
  { key: "pe", flag: "pe", text: "Peru", value: "pe" },
  { key: "ph", flag: "ph", text: "Philippines", value: "ph" },
  { key: "pn", flag: "pn", text: "Pitcairn Islands", value: "pn" },
  { key: "pl", flag: "pl", text: "Poland", value: "pl" },
  { key: "pt", flag: "pt", text: "Portugal", value: "pt" },
  { key: "pr", flag: "pr", text: "Puerto Rico", value: "pr" },
  { key: "qa", flag: "qa", text: "Qatar", value: "qa" },
  { key: "re", flag: "re", text: "Reunion", value: "re" },
  { key: "ro", flag: "ro", text: "Romania", value: "ro" },
  { key: "ru", flag: "ru", text: "Russia", value: "ru" },
  { key: "rw", flag: "rw", text: "Rwanda", value: "rw" },
  { key: "sh", flag: "sh", text: "Saint Helena", value: "sh" },
  { key: "kn", flag: "kn", text: "Saint Kitts and Nevis", value: "kn" },
  { key: "lc", flag: "lc", text: "Saint Lucia", value: "lc" },
  { key: "pm", flag: "pm", text: "Saint Pierre", value: "pm" },
  { key: "vc", flag: "vc", text: "Saint Vincent", value: "vc" },
  { key: "ws", flag: "ws", text: "Samoa", value: "ws" },
  { key: "sm", flag: "sm", text: "San Marino", value: "sm" },
  { key: "gs", flag: "gs", text: "Sandwich Islands", value: "gs" },
  { key: "st", flag: "st", text: "Sao Tome", value: "st" },
  { key: "sa", flag: "sa", text: "Saudi Arabia", value: "sa" },
  { key: "gb sct", flag: "gb sct", text: "Scotland", value: "gb sct" },
  { key: "sn", flag: "sn", text: "Senegal", value: "sn" },
  { key: "cs", flag: "cs", text: "Serbia and Montenegro", value: "cs" },
  { key: "rs", flag: "rs", text: "Serbia", value: "rs" },
  { key: "sc", flag: "sc", text: "Seychelles", value: "sc" },
  { key: "sl", flag: "sl", text: "Sierra Leone", value: "sl" },
  { key: "sg", flag: "sg", text: "Singapore", value: "sg" },
  { key: "sk", flag: "sk", text: "Slovakia", value: "sk" },
  { key: "si", flag: "si", text: "Slovenia", value: "si" },
  { key: "sb", flag: "sb", text: "Solomon Islands", value: "sb" },
  { key: "so", flag: "so", text: "Somalia", value: "so" },
  { key: "za", flag: "za", text: "South Africa", value: "za" },
  { key: "kr", flag: "kr", text: "South Korea", value: "kr" },
  { key: "es", flag: "es", text: "Spain", value: "es" },
  { key: "lk", flag: "lk", text: "Sri Lanka", value: "lk" },
  { key: "sd", flag: "sd", text: "Sudan", value: "sd" },
  { key: "sr", flag: "sr", text: "Suriname", value: "sr" },
  { key: "sz", flag: "sz", text: "Swaziland", value: "sz" },
  { key: "se", flag: "se", text: "Sweden", value: "se" },
  { key: "ch", flag: "ch", text: "Switzerland", value: "ch" },
  { key: "sy", flag: "sy", text: "Syria", value: "sy" },
  { key: "tw", flag: "tw", text: "Taiwan", value: "tw" },
  { key: "tj", flag: "tj", text: "Tajikistan", value: "tj" },
  { key: "tz", flag: "tz", text: "Tanzania", value: "tz" },
  { key: "th", flag: "th", text: "Thailand", value: "th" },
  { key: "tl", flag: "tl", text: "Timorleste", value: "tl" },
  { key: "tg", flag: "tg", text: "Togo", value: "tg" },
  { key: "tk", flag: "tk", text: "Tokelau", value: "tk" },
  { key: "to", flag: "to", text: "Tonga", value: "to" },
  { key: "tt", flag: "tt", text: "Trinidad", value: "tt" },
  { key: "tn", flag: "tn", text: "Tunisia", value: "tn" },
  { key: "tr", flag: "tr", text: "Turkey", value: "tr" },
  { key: "tm", flag: "tm", text: "Turkmenistan", value: "tm" },
  { key: "tv", flag: "tv", text: "Tuvalu", value: "tv" },
  {
    key: "ae",
    flag: "ae",
    text: "UAE",
    value: "ae",
    alias: "United Arab Emirates",
  },
  { key: "ug", flag: "ug", text: "Uganda", value: "ug" },
  { key: "ua", flag: "ua", text: "Ukraine", value: "ua" },
  { key: "uk", flag: "uk", text: "United Kingdom", value: "gb", alias: "uk" },
  {
    key: "us",
    flag: "us",
    text: "USA",
    value: "us",
    alias: "America",
  },
  { key: "uy", flag: "uy", text: "Uruguay", value: "uy" },
  { key: "um", flag: "um", text: "US Minor Islands", value: "um" },
  { key: "vi", flag: "vi", text: "US Virgin Islands", value: "vi" },
  { key: "uz", flag: "uz", text: "Uzbekistan", value: "uz" },
  { key: "vu", flag: "vu", text: "Vanuatu", value: "vu" },
  { key: "va", flag: "va", text: "Vatican City", value: "va" },
  { key: "ve", flag: "ve", text: "Venezuela", value: "ve" },
  { key: "vn", flag: "vn", text: "Vietnam", value: "vn" },
  { key: "gb wls", flag: "gb wls", text: "Wales", value: "gb wls" },
  { key: "wf", flag: "wf", text: "Wallis and Futuna", value: "wf" },
  { key: "eh", flag: "eh", text: "Western Sahara", value: "eh" },
  { key: "ye", flag: "ye", text: "Yemen", value: "ye" },
  { key: "zm", flag: "zm", text: "Zambia", value: "zm" },
  { key: "zw", flag: "zw", text: "Zimbabwe", value: "zw" },
  { key: "bq", flag: "bq", text: "Bonaire", value: "bq" },
]

export const usStateOptions = [
  { key: "AL", value: "AL", text: "Alabama" },
  { key: "AK", value: "AK", text: "Alaska" },
  { key: "AZ", value: "AZ", text: "Arizona" },
  { key: "AR", value: "AR", text: "Arkansas" },
  { key: "CA", value: "CA", text: "California" },
  { key: "CO", value: "CO", text: "Colorado" },
  { key: "CT", value: "CT", text: "Connecticut" },
  { key: "DE", value: "DE", text: "Delaware" },
  { key: "FL", value: "FL", text: "Florida" },
  { key: "GA", value: "GA", text: "Georgia" },
  { key: "HI", value: "HI", text: "Hawaii" },
  { key: "ID", value: "ID", text: "Idaho" },
  { key: "IL", value: "IL", text: "Illinois" },
  { key: "IN", value: "IN", text: "Indiana" },
  { key: "IA", value: "IA", text: "Iowa" },
  { key: "KS", value: "KS", text: "Kansas" },
  { key: "KY", value: "KY", text: "Kentucky" },
  { key: "LA", value: "LA", text: "Louisiana" },
  { key: "ME", value: "ME", text: "Maine" },
  { key: "MD", value: "MD", text: "Maryland" },
  { key: "MA", value: "MA", text: "Massachusetts" },
  { key: "MI", value: "MI", text: "Michigan" },
  { key: "MN", value: "MN", text: "Minnesota" },
  { key: "MS", value: "MS", text: "Mississippi" },
  { key: "MO", value: "MO", text: "Missouri" },
  { key: "MT", value: "MT", text: "Montana" },
  { key: "NE", value: "NE", text: "Nebraska" },
  { key: "NV", value: "NV", text: "Nevada" },
  { key: "NH", value: "NH", text: "New Hampshire" },
  { key: "NJ", value: "NJ", text: "New Jersey" },
  { key: "NM", value: "NM", text: "New Mexico" },
  { key: "NY", value: "NY", text: "New York" },
  { key: "NC", value: "NC", text: "North Carolina" },
  { key: "ND", value: "ND", text: "North Dakota" },
  { key: "OH", value: "OH", text: "Ohio" },
  { key: "OK", value: "OK", text: "Oklahoma" },
  { key: "OR", value: "OR", text: "Oregon" },
  { key: "PA", value: "PA", text: "Pennsylvania" },
  { key: "RI", value: "RI", text: "Rhode Island" },
  { key: "SC", value: "SC", text: "South Carolina" },
  { key: "SD", value: "SD", text: "South Dakota" },
  { key: "TN", value: "TN", text: "Tennessee" },
  { key: "TX", value: "TX", text: "Texas" },
  { key: "UT", value: "UT", text: "Utah" },
  { key: "VT", value: "VT", text: "Vermont" },
  { key: "VA", value: "VA", text: "Virginia" },
  { key: "WA", value: "WA", text: "Washington" },
  { key: "WV", value: "WV", text: "West Virginia" },
  { key: "WI", value: "WI", text: "Wisconsin" },
  { key: "WY", value: "WY", text: "Wyoming" }
];